import React, { useState } from "react";
import {
  ListContainer,
  Button,
  WalletItem,
  WalletInfo,
  WalletActions,
} from "./CriptoWallets.styles";
import { IconButton, Typography, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import StarIcon from "@mui/icons-material/Star";

const CriptoWalletList = ({
  wallets,
  onEdit,
  onDelete,
  onSetDefault,
  readOnly = false,
}) => {
  const [visibleAddresses, setVisibleAddresses] = useState({});

  const toggleAddressVisibility = (index) => {
    setVisibleAddresses((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const maskAddress = (address) => {
    if (!address) return "";
    if (address.length <= 8) return address;
    return `${address.substring(0, 4)}...${address.substring(
      address.length - 4
    )}`;
  };

  return (
    <ListContainer>
      {wallets.map((wallet, index) => (
        <WalletItem
          key={`wallet-${index}`}
          sx={{
            border: wallet.is_default ? 2 : 1,
            borderColor: wallet.is_default ? "warning.main" : "divider",
            bgcolor: wallet.is_default ? "warning.light" : "background.paper",
            position: "relative",
          }}
        >
          {wallet.is_default && (
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                bgcolor: "warning.main",
                color: "warning.contrastText",
                padding: "2px 8px",
                borderRadius: 1.5,
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              <StarIcon sx={{ fontSize: 14 }} />
              Default
            </Box>
          )}

          <WalletInfo>
            <div>
              <strong>Crypto:</strong> {wallet.crypto_currency_code}
            </div>
            <div>
              <strong>Network:</strong> {wallet.network_code}
            </div>
            {wallet.memo_tag && (
              <div>
                <strong>Memo Tag:</strong> {wallet.memo_tag}
              </div>
            )}
            <div>
              <strong>Wallet Type:</strong>
              <span style={{ textTransform: "uppercase" }}>
                {wallet.wallet_type}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <strong>Wallet Address:</strong>
              <IconButton
                size="small"
                onClick={() => toggleAddressVisibility(index)}
                sx={{ padding: "4px", color: "primary.main" }}
              >
                {visibleAddresses[index] ? (
                  <VisibilityOffIcon sx={{ fontSize: 18 }} />
                ) : (
                  <VisibilityIcon sx={{ fontSize: 18 }} />
                )}
              </IconButton>
              <Typography
                component="span"
                sx={{
                  fontFamily: "monospace",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "0.875rem",
                }}
              >
                {visibleAddresses[index]
                  ? wallet.wallet_address
                  : maskAddress(wallet.wallet_address)}
              </Typography>
            </div>
          </WalletInfo>
          <WalletActions>
            {onEdit && !readOnly && (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => onEdit(wallet, index)}
              >
                Edit
              </Button>
            )}
            {onSetDefault && !wallet.is_default && !readOnly && (
              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => onSetDefault(index)}
                sx={{
                  borderColor: "warning.main",
                  color: "warning.main",
                  "&:hover": {
                    borderColor: "warning.dark",
                    bgcolor: "warning.light",
                  },
                }}
              >
                Set as Default
              </Button>
            )}
            {onDelete && !readOnly && (
              <Button
                variant="outlined"
                color="error"
                size="small"
                onClick={() => onDelete(index)}
              >
                Delete
              </Button>
            )}
          </WalletActions>
        </WalletItem>
      ))}
      {wallets.length === 0 && (
        <Typography variant="h5" color="text.secondary" align="center">
          No wallets found
        </Typography>
      )}
    </ListContainer>
  );
};

export default CriptoWalletList;
